import React from "react";
import { PersonalData } from "../../data/personal";
import "./personal-contact.css";
function PersonalContact() {
  const data = PersonalData;
  return (
    <div className="personal-contact">
      {data.map((item) => {
        return (
          <div className="personal-icon-div" key={item.value}>
            {/* <img alt="" src={item.icon} className="personal-icon" /> */}
            {item.icon}
            <p>{item.value}</p>
          </div>
        );
      })}
    </div>
  );
}

export default PersonalContact;
